module.exports = __webpack_public_path__ + "static/Tile4-infrared-d8029eaf14ea7bae7ed5939fa3c51108.gif";